import {
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GLOBALS } from 'app/config/globals';
import { AuthenticationService, DropdownsService } from 'app/services';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { BaseService } from 'app/_helpers/base/base.service';
import { forEach, map, uniq } from 'lodash';
import { merge, Subject } from 'rxjs';
import { distinctUntilChanged, startWith, switchMap, takeUntil, debounceTime, tap } from 'rxjs/operators';
import { OwnersCreateComponent } from '../../owners-create.component';
import * as _ from 'lodash';
import { fuseAnimations } from '@fuse/animations';
import { GlobalFuntions } from 'app/_helpers';
@Component({
    selector: 'tab-agency',
    templateUrl: './tab-agency.component.html',
    styleUrls: ['./tab-agency.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class TabAgencyComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;

    customSettings: UntypedFormArray;
    custom1Settings: UntypedFormArray;
    searchLanguages: UntypedFormControl = new UntypedFormControl('');
    searchLeadStatus: UntypedFormControl = new UntypedFormControl('');
    leadstatus: any;
    searchProbability: UntypedFormControl = new UntypedFormControl('');
    seriesSearch: UntypedFormControl = new UntypedFormControl('');
    searchGDPRstatus: UntypedFormControl = new UntypedFormControl('');
    searchOffices$ = new Subject<string>();
    searchCompany: UntypedFormControl = new UntypedFormControl('');
    searchContactData$ = new Subject<string>();
    offices: any;
    public invoiceSeries = [];
    officeGroups = [] as any;
    companyData: any;
    selectedProbability: any;
    languages: any;
    systemlang: any;
    currencies: any;
    contactData: any;
    searching: any;
    filter: any = {};
    public queryOptions: any;
    private _unsubscribeAll: Subject<any>;
    currentOffice: any;
    isReadOnly = false;
    probabilities = [
        {
            value: '0 - 20 %',
            class: 'blue-dot',
        },
        {
            value: '21 - 50 %',
            class: 'green-dot',
        },
        {
            value: '51 - 70 %',
            class: 'yellow-dot',
        },
        {
            value: '71 - 99 %',
            class: 'red-dot',
        },
        {
            value: '100 %',
            class: 'gray-dot',
        },
    ];
    probabilitiesArray: any;
    gdpr = [
        {
            value: '0',
            name: 'No value',
        },
        {
            value: '1',
            name: 'Accepted',
        },
        {
            value: '2',
            name: 'Pending',
        },
        {
            value: '3',
            name: 'no-permission',
        },
    ];
    gdprArray = this.gdpr;
    _ownersCreateComponent: OwnersCreateComponent;
    sources: any;
    isInvoiceModule: any;
    public paymentMethods = [];
    public loaders = { ...GLOBALS.loaders }; // To display/hide loading spinner
    currentUser: any;
    ownerLeadStatusesQuery = {
        "query": {},
        "options": {
            "page": 1,
            "limit": 20,
            "sort": {}
        }
    }

    /**
     * Constructor
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _translateService: TranslateService,
        private _dropdownsService: DropdownsService,
        private injector: Injector,
        private _crmMenuService: CrmMenuService,
        private _gService: BaseService,
        private _authenticationService: AuthenticationService,
        private _globalFunctions: GlobalFuntions,
    ) {
        this.systemlang =
            this._translateService.currentLang === 'es'
                ? 'es_AR'
                : this._translateService.currentLang;
        this.isInvoiceModule = this._crmMenuService.isInvoiceModule;
        this._unsubscribeAll = new Subject();
        this.currentOffice = this._authenticationService.currentOfficeValue;
        this.currentUser = this._authenticationService.currentUserValue;
    }

    ngOnInit(): void {
        this._translateService.onLangChange.subscribe(() => {
            this.systemlang = this._translateService.currentLang;
            this.ownerSources();
        });
        if (!this.form) {
            this._ownersCreateComponent = this.injector.get(
                OwnersCreateComponent
            ) as OwnersCreateComponent;
            this.form = this._ownersCreateComponent.form;
        }
        this.probabilitiesArray = this.probabilities;

        if (!this?.currentUser?.user_master_office) {
            this.isReadOnly = true;
        }
        this.customSettings = this.form.get('financial_accounts') as UntypedFormArray;

        this.custom1Settings = this.form.get('custom_settings') as UntypedFormArray;

        if (this.custom1Settings.length === 0) {
            this.custom1Settings.push(this.create1Customs());
        }

        this._dropdownsService.getCurrencies().subscribe((data: any) => {
            this.currencies = data;
        });

        this._dropdownsService.getOwnerLeadStatuses(this.ownerLeadStatusesQuery).subscribe((data: any) => {
            let leadData = [];
            if(data?.docs) {
                leadData = map(data.docs, (element) => {
                    if (element.key && typeof element.key == 'string') {
                        element.key = parseInt(element.key);
                    }
                    return element;
                });
            }
            this.leadstatus = leadData;
        });

        this.searchOffices$
            .pipe(
                startWith(''),
                switchMap((search: string) => {
                    return this._dropdownsService.getOffices(search);
                })
            )
            .subscribe((data: any) => {
                this.offices = data.body;
                this.offices.sort((a, b) => {
                    if (a.name.toUpperCase() < b.name.toUpperCase()) {
                        return -1;
                    }
                    return 1;
                });
                forEach(this.offices, (value) => {
                    if (value.office_groups) {
                        if (typeof value.office_groups == 'object') {
                            value.office_groups.forEach((group) => {
                                this.officeGroups.push(group);
                            });
                        } else {
                            this.officeGroups.push(value.office_groups);
                        }
                    }
                });
                this.officeGroups = uniq(this.officeGroups);
                this.officeGroups.sort();
            });
        merge(this.searchCompany.valueChanges)
            .pipe(
                startWith(''),
                tap(),
                switchMap(() => {
                    return this._dropdownsService.getCompaniesList(
                        this.searchCompany.value,
                        'Agency'
                    );
                })
            )
            .subscribe((data: any) => {
                this.companyData = data.body;
            });
        this.searchContactData$
            .pipe(
                startWith(''),
                distinctUntilChanged(),
                takeUntil(this._unsubscribeAll),
                switchMap((search: string) => {
                    return this._dropdownsService.getAllAgencyUsers(search);
                })
            )
            .subscribe((data: any) => {
                _.forEach(data, (value) => {
                    value.disabled =
                        (
                            !this.currentOffice.master_office &&
                            this.currentOffice._id !== value.office
                        )
                            ? true
                            : (
                                this.currentUser?.user_role == 'agency_manager' ||
                                    this.currentOffice.master_office ? false : true
                            );
                    value.label = _.isEmpty(_.trim(value.full_name))
                        ? value.full_name
                        : value.forename;
                });
                this.contactData = data;
            });

        this.searchProbability.valueChanges.subscribe((data: string) => {
            this.probabilitiesArray = this.probabilities;
            if (data !== '') {
                this.probabilitiesArray = this.probabilities.filter((s) =>
                    s.value.includes(data)
                );
            }
        });

        this.seriesSearch.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                tap(() => (this.searching = true)),
                switchMap((search) => {
                    if (search && search !== '') {
                        // Required in this way to perform search on backend.
                        const description = 'description.' + this.systemlang;
                        this.queryOptions = { [description]: { $regex: '.*' + this._globalFunctions.caseAndAccentInsensitive(search) + '.*', $options: 'i' } };
                    }
                    return this._gService.post(`invoice-series`, { query: this.queryOptions }, 'nodejs');
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.invoiceSeries = data.docs;
                this.loaders['invoiceSeries'] = false;
            });

        this.searchGDPRstatus.valueChanges.subscribe((data: string) => {
            this.gdprArray = this.gdpr;
            if (data !== '') {
                // this.gdprArray = FuseUtils.filterArrayByString(this.gdpr, data);
                this.gdprArray = this.gdpr.filter((s) =>
                    s.value.toLowerCase().includes(data.toLowerCase())
                );
            }
        });

        this.ownerSources();
        this._initPage();
    }

    ownerSources() {
        this._dropdownsService.getSources('Owners').subscribe((data: any) => {
            this.sources = data.body;
        });
    }

    createCustoms(): UntypedFormGroup {
        return this._formBuilder.group({
            account_holder: [{ value: '', disabled: false }],
            iban: [{ value: null, disabled: false }],
            bic_swift: [{ value: '', disabled: false }],
            avg_balance: [{ value: '', disabled: false }],
            account_currency: [{ value: '', disabled: false }],
        });
    }

    create1Customs(): UntypedFormGroup {
        return this._formBuilder.group({
            key: [{ value: '', disabled: false }],
            value: [{ value: '', disabled: false }],
        });
    }
    // tslint:disable-next-line:typedef
    selectProbability(e) {
        this.selectedProbability = this.probabilities.filter((s) =>
            s.value.includes(e)
        )[0].class;
    }
    async _initPage(): Promise<any> {
        this._findPaymentMethods();
    }
    private _findPaymentMethods(): void {
        this.loaders['paymentMethod'] = true;
        const queryOptions = {
            where: {},
            select: 'description',
            options: { sort: { description: 1 } },
        };
        this._gService
            .post(`payment-modes`, { queryOptions: queryOptions }, 'nodejs')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data: any) => {
                this.paymentMethods = data.docs;
                this.loaders['paymentMethod'] = false;
            });
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
